"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { CollectedCollectionType, CollectionSeized } from "@/entities/IProfile";
import { MEMES_SEASON } from "@/enums";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { ProfileCollectedFilters } from "../UserPageCollected";
export default function UserPageCollectedCardsNoCards(t0) {
  const $ = _c(10);
  const {
    filters
  } = t0;
  let t1;
  if ($[0] !== filters.collection || $[1] !== filters.seized || $[2] !== filters.szn) {
    t1 = () => {
      if (filters.seized !== CollectionSeized.NOT_SEIZED) {
        return "No cards to display";
      }
      switch (filters.collection) {
        case null:
          {
            return "Congratulations, full setter!";
          }
        case CollectedCollectionType.MEMES:
          {
            switch (filters.szn) {
              case null:
                {
                  return "Congratulations, The Memes full setter!";
                }
              case MEMES_SEASON.SZN1:
              case MEMES_SEASON.SZN2:
              case MEMES_SEASON.SZN3:
              case MEMES_SEASON.SZN4:
              case MEMES_SEASON.SZN5:
              case MEMES_SEASON.SZN6:
              case MEMES_SEASON.SZN7:
              case MEMES_SEASON.SZN8:
              case MEMES_SEASON.SZN9:
              case MEMES_SEASON.SZN10:
              case MEMES_SEASON.SZN11:
              case MEMES_SEASON.SZN12:
              case MEMES_SEASON.SZN13:
                {
                  return `Congratulations, ${filters.szn} full setter!`;
                }
              default:
                {
                  assertUnreachable(filters.szn);
                  return "";
                }
            }
          }
        case CollectedCollectionType.GRADIENTS:
          {
            return "Congratulations, Gradient full setter!";
          }
        case CollectedCollectionType.MEMELAB:
          {
            return "Congratulations, Meme Lab full setter!";
          }
        case CollectedCollectionType.NEXTGEN:
          {
            return "Congratulations, Next Gen full setter!";
          }
        default:
          {
            assertUnreachable(filters.collection);
            return "";
          }
      }
    };
    $[0] = filters.collection;
    $[1] = filters.seized;
    $[2] = filters.szn;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getMsg = t1;
  const [msg, setMsg] = useState(getMsg());
  let t2;
  if ($[4] !== getMsg) {
    t2 = () => {
      setMsg(getMsg());
    };
    $[4] = getMsg;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== filters) {
    t3 = [filters];
    $[6] = filters;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== msg) {
    t4 = <div className="tw-py-4 tw-text-sm tw-italic tw-text-iron-500">{msg}</div>;
    $[8] = msg;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}